import { Box } from "@chakra-ui/react"

import { HeadSkeleton, FilterSkeleton, TableSkeleton } from 'View/report-attendance/component/skeleton'

import styles from './styles.module.css'

const ReportAttendanceSkeleton = () => {
    return (
        <Box className={styles['skeleton__container']}>
            <Box className={styles['skeleton__head--container']}>
                <HeadSkeleton />
            </Box>
            <Box className={styles['skeleton__filter--container']}>
                <FilterSkeleton />
            </Box>
            <Box className={styles['skeleton__table--container']}>
                <TableSkeleton />
            </Box>
        </Box>
    )

}

export default ReportAttendanceSkeleton